export const isIE = /*@cc_on!@*/false || typeof document !== 'undefined' && !!document.documentMode;
